import JInput from './JInput';

export default JInput;
